//
//

import AQSearch from "@/components/Generics/AQSearch/AQSearch.vue";
import { mapActions, mapGetters } from "vuex";
import { publishAppPermissions } from "@/assets/js/appFunc";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQEmptyState from "@/components/Generics/AQEmptyState/AQEmptyState.vue";
import AQSkeleton from "@/components/Generics/AQSkeleton/AQSkeleton.vue";
import AQEmptySearch from "@/components/Generics/AQEmptySearch/AQEmptySearch.vue";
import MethodsModal from "../consume/methods-modal/methodsModal.vue";

export default {
    name: "InternalApi",
    components: {
        AQSearch,
        AQTooltip,
        MethodsModal,
        AQEmptyState,
        AQSkeleton,
        AQEmptySearch
    },
    props: {
        skeletonState: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            search: "",
            showSearch: false,
            showMethodDetails: false,
            showTooltipInfo: false,
            requestObj: {},
            responseObj: {},
            methodsModalData: null,
            searchTrigger: false,
            searchInputTriggered: false
        };
    },
    computed: {
        ...mapGetters("apis", ["getAllInternalApis"]),
        ...mapGetters("apps", ["currentApp", "getCurrentAppUserPermissions", "processList"]),
        hasInternalApis() {
            return this.getAllInternalApis && this.getAllInternalApis.length;
        },
        filteredAllInternalApis() {
            let apis = [];
            const { query } = this.$route;
            if (query && Object.keys(query).length && query.search && !this.searchInputTriggered) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.searchTrigger = false;
                this.$nextTick(() => {
                    this.searchTrigger = true;
                    this.search = query.search;
                });
            }
            if (this.search) {
                const lowerCaseValue = this.search.toLowerCase();
                apis = this.getAllInternalApis.filter(item => (item.name || "")
                    .toLowerCase()
                    .includes(lowerCaseValue));
            } else {
                apis = this.getAllInternalApis;
            }
            apis.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
            return apis;
        }
    },
    watch: {
        showSearch: {
            handler(newVal) {
                this.searchTrigger = newVal;
                setTimeout(() => {
                    this.searchTrigger = false;
                }, 0);
            },
            immediate: true
        }
    },
    created() {
        this.showPublishBtn();
    },
    deactivated() {
        this.search = "";
        this.searchInputTriggered = false;
    },
    methods: {
        ...mapActions("diagrams", ["getRequestResponse"]),
        ...mapActions("apps", ["getAppSettingsInfo"]),
        ...mapActions("apis", ["integrationURL"]),
        openMethodDetails(item, method) {
            const payload = {
                apiId: item.id,
                method
            };
            Promise.all([
                this.integrationURL(payload),
                this.getRequestResponse(payload)
            ]).then(([url, reqResp]) => {
                this.requestObj = { data: reqResp.data.object, tab: "request" };
                this.responseObj = { data: reqResp.data.object, tab: "response" };
                this.methodsModalData = {
                    method,
                    internalURL: url,
                    requestObj: this.requestObj,
                    responseObj: this.responseObj
                };
                this.showMethodDetails = true;
            });
        },
        showPublishBtn() {
            this.getAppSettingsInfo(this.currentApp).then(data => {
                this.currentApp.publishStatus = data.data.publishStatus;
                this.$store.commit("apps/setCurrentApp", this.currentApp);
                this.$root.$emit("showPublish", {
                    noProcesses: this.currentApp.hasOwnProperty("nrOfProcesses") ? !this.currentApp.nrOfProcesses : !this.processList.length,
                    showPublish: publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions)
                });
            });
        },
        checkIfEllipsis(ref, index) {
            const { [ref]: el } = this.$refs;
            if (el) {
                this.showTooltipInfo = el[index].scrollWidth > el[index].offsetWidth;
            }
        },
        changeSearchUrl(value) {
            const searchText = value.trim();
            const queriesAreDifferent = JSON.stringify({ search: searchText }) !== JSON.stringify(this.$route.query);
            const query = searchText ? { search: searchText } : {};
            this.searchInputTriggered = true;
            if (queriesAreDifferent) {
                this.$router.replace({ path: `/applications/${this.currentApp.id}/integrations/systemApi`, query });
            }
        }
    }
};
